import {VueReCaptcha} from 'vue-recaptcha-v3'
import Notify from 'quasar/src/plugins/Notify.js';import Loading from 'quasar/src/plugins/Loading.js';import setCssVar from 'quasar/src/utils/set-css-var.js';;
import {store} from '@/main'
import favicon from "favicon.js"


let reCaptchaIsLoaded = false;

export function isReCaptchaLoaded() {
    return reCaptchaIsLoaded;
}
export function setReCaptchaIsLoaded() {
    reCaptchaIsLoaded = true;
}

export function initReCaptcha(app) {
    let url = '/front/api/v1/init';
    if(window.location.href.indexOf("localhost") >= 0) {
        url = "http://localhost:9001/app_dev.php" + url;
    }
    Loading.show({group: 'ReCaptcha'})
    return fetch(url,
        {
            method: 'GET',
            //credentials: 'include',
            headers: {
                'Accept': 'application/json',
                'Content-type': 'application/json',
            }
        })
        .then(
            response => response.json()
        ) .then(
            (response) => {
                if(response.key === undefined || !response.key) {
                    Notify.create(
                        {
                            message: '<p><em>Something went wrong: initReCaptcha</em></p>',
                            html: true,
                            timeout:5000
                        });
                } else {
                    if(!isReCaptchaLoaded()) {
                        app.use(VueReCaptcha, {siteKey: response.key});
                        setReCaptchaIsLoaded();
                    }
                    console.log('ReCaptcha init success');
                    Loading.hide('ReCaptcha');
                    if(response.user !== undefined && response.user.authenticated === true) {
                        store.dispatch('settings/list/authenticateUser', response.user);
                        store.dispatch('settings/list/prefillUserM1', response.user);

                    }
                    if(response.background) {
                        setCssVar('bg', '#' + response.background);
                    }
                    if(response.logo) {
                        store.dispatch('values/list/setLogo', {logo: response.logo});
                    }

                    if(response.company && response.favicon) {
                        favicon.change(response.favicon, response.company);
                    }

                    if(response.email) {
                        store.dispatch(
                            'settings/list/assignSite',
                            {
                                company: response.company,
                                email: response.email,
                                logo: response.logo,
                            }
                        );
                    }
                }
            })
        .catch(error => console.log(error));
}